import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { css } from "styled-components";

productListStyles.sortOrderTextField = {
    labelPosition: "top",
    labelProps: {
        size: 9,
        transform: "uppercase",
        css: css`
            min-height: auto;
            text-align: center;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                opacity: 1;
            }
        `, // AMR-328 forced number inputs to always be visible
        formField: css`
            margin-top: 10px;
        `,
        inputSelect: css`
            text-align: center;

            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -moz-appearance: textfield;
        `,
    },
};
